import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from '../pages/login/login';
import Register from '../pages/register/register';
import Events from '../pages/event/event';
import Applications from '../pages/applications/applications';
import Groups from '../pages/groups/group';
import Contestants from '../pages/contestants/contestant';
import Passes from '../pages/passes/passes';
import FrontendForm from '../pages/frontendForm/frontendForm';
import Profile from '../pages/profile/profile';
import InvoicePage from '../pages/invoices/invoices';
import Settings from '../pages/settings/settings';
import Stats from '../pages/stats/stats';
import Schedule from '../pages/schedule/schedule';
import Merchandise from '../pages/merchandise/merchandise';
import BuyPasses from '../pages/frontendPasses/frontendPasses';
import MerchandisePage from '../pages/frontendMerchandise/frontendMerchandise';
import Venues from '../pages/venues/venues';
import SchedulingPage from '../pages/scheduling/scheduling';
import Grading from '../pages/grading/grading';
import CreateContestant from '../pages/createContestant/createContestant';
import ContestantRoute from './contestantRoute';
import ResetPassword from '../pages/passwordReset/passwordReset';
import Entries from '../pages/entries/entries';
import Judging from '../pages/judging/judging';
import { PrivateRoute, PublicRoute } from "./privateRoute";

const AppRouter = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<PublicRoute component={Login} />} />
                <Route path="/register" element={<PublicRoute component={Register} />} />
                <Route path="/events" element={<PrivateRoute component={Events} allowedRoles={['admin']} />} />
                <Route path="/contestants" element={<PrivateRoute component={Contestants} allowedRoles={['admin', 'guardian']} />} />
                <Route path="/entries" element={<PrivateRoute component={Entries} allowedRoles={['admin', 'guardian']} />} />
                <Route path="/applications" element={<PrivateRoute component={Applications} allowedRoles={['admin', 'guardian', 'contestant']} />} />
                <Route path="/groups" element={<PrivateRoute component={Groups} allowedRoles={['admin', 'guardian', 'contestant']} />} />
                <Route path="/profile" element={<PrivateRoute component={Profile} allowedRoles={['contestant']} />} />
                <Route path="/invoice" element={<PrivateRoute component={InvoicePage} allowedRoles={['contestant']} />} />
                <Route path="/settings" element={<PrivateRoute component={Settings} allowedRoles={['admin']} />} />
                <Route path="/statistics" element={<PrivateRoute component={Stats} allowedRoles={['admin']} />} />
                <Route path="/apply" element={<PublicRoute component={FrontendForm} />} />
                <Route path="/venues" element={<PrivateRoute component={Venues} allowedRoles={['admin']} />} />
                <Route path="/scheduling" element={<PrivateRoute component={SchedulingPage} allowedRoles={['admin']} />} />
                <Route path="/grading" element={<PrivateRoute component={Grading} allowedRoles={['admin']} />} />
                <Route path="/judging" element={<PrivateRoute component={Judging} allowedRoles={['admin', 'judge']} />} />
                <Route path="/new-contestant" element={<ContestantRoute component={CreateContestant} />} />
                <Route path="/password-reset" element={<PublicRoute component={ResetPassword} />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;  
